// ======================================================================
// File Name       : EnterprisePreCancelContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import * as enterpriseActions from '../../actions/EnterpriseAction';
import * as modalActions from '../../actions/ModalAction';
import EnterprisePreCancelForm from '../../components/enterprise/EnterprisePreCancelForm';
import ModalWrapper from '../../components/modal/ModalWrapper';
import { ENTERPRISE_PRECANCEL_CONFIRM, ENTERPRISE_REASON_FOR_CANCEL } from '../../constants/ModalIds';
import { hideLoading, showLoading } from '../../utils/PageUtils';

class EnterprisePreCancelContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      checkbox1: false,
      checkbox2: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
  }

  getModalOptions() {
    const { checkbox1, checkbox2 } = this.state;
    return {
      title: '解約前のご確認',
      footerBtns: [
        { name: '解約をキャンセル', onClick: this.props.hideModal },
        {
          name: '解約する',
          onClick: this.handleSubmit,
          className: 'btn-enterpriseCancel',
          disabled: !checkbox1 || !checkbox2,
        },
      ],
    };
  }

  handleSubmit() {
    const { dispatch, authedUser, enterpiseReason, enterpriseCd, enterpriseNotChild } = this.props;
    const { authCd } = authedUser;
    const enterpriseCdTarget = enterpriseNotChild ? enterpriseNotChild.enterpriseCd : enterpriseCd; // step 11.2.0
    const params = {
      authCd,
      enterpriseCd: enterpriseCdTarget, // step 11.2.0
    };

    dispatch(showLoading());
    dispatch(enterpriseActions.reasonForCancelEnterprise(enterpiseReason)).then((cancelError) => {
      if (!cancelError) {
        dispatch(enterpriseActions.preCancelEnterprise(params)).then((preCancelError) => {
          if (!preCancelError) {
            dispatch(enterpriseActions.saveEnterpriseReason(null));
            dispatch(enterpriseActions.init());
            dispatch(modalActions.openModal(ENTERPRISE_PRECANCEL_CONFIRM));
            dispatch(hideLoading());
          }
          dispatch(hideLoading());
        });
      }
      dispatch(hideLoading());
    });
  }

  onChangeCheckbox(event) {
    const { name, checked } = event.target;
    this.setState({
      ...{ [name]: checked },
    });
  }

  render() {
    return (
      <ModalWrapper {...this.getModalOptions()} hideModal={this.props.hideModal}>
        <EnterprisePreCancelForm
          onChangeCheckbox={this.onChangeCheckbox}
        />
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { authedUser } = state.authed;
  const { enterpiseReason, editingEnterprise: { enterpriseCd }, enterprises } = state.enterprise;
  const enterpriseNotChild = enterprises.isEnterpriseNotChild
    ? enterprises.bySecernId[Object.keys(enterprises.bySecernId)[0]]
    : null; // step 11.2.0
  return {
    authedUser,
    enterpiseReason,
    enterpriseCd, // sprint_20230605_tma
    enterpriseNotChild, // step 11.2.0
  };
};

export default connect(mapStateToProps)(EnterprisePreCancelContainer);
